import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["variant"];
import { IconContainer } from './IconContainer';
import { BreezeSingleStarIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
export const BreezeIcon = _ref => {
  let {
      variant = 'breeze'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(IconContainer, Object.assign({}, rest, {
    variant: variant,
    children: /*#__PURE__*/_jsx(BreezeSingleStarIcon, {})
  }));
};